import { useQuery } from '@tanstack/react-query';
import { useLocation, useSearchParams } from 'react-router';
import { api } from '@/lib/api';
import { resolveEnvironment, type AppDetail } from '@/lib/types';
import { currentAppRoute } from './nav';

/** Same query key and fetcher as AppLayout, so the sidebar and breadcrumbs share its cache entry. */
export function useCurrentApp() {
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const route = currentAppRoute(pathname);
  const q = useQuery({
    queryKey: ['app', route?.appId],
    enabled: !!route,
    queryFn: () => api<AppDetail>(`/admin/v1/apps/${route!.appId}`),
  });
  const app = route ? q.data : undefined;
  return { route, env: resolveEnvironment(app, params.get('env')), app };
}
